export const indexIsFlipped = (index: number) => index % 2 === 0
